import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { SEARCH_QUERY } from '../../graphql.js'
import SearchForm from './SearchForm'

const SEARCH = gql(SEARCH_QUERY)

export default function SearchFormContainer({ location, match }) {
  console.log('SearchFormContainer rendered:',location)
  console.log('SearchFormContainer rendered:', match)

  const { loading, error, data } = useQuery(SEARCH, { variables: { id: match.params.id } })

  if (error) {
    console.log(`SearchFormContainer: ${error.message}`)
    return ''
  }
  if (loading) {
    return <Spinner />
  }
  if (data.search) {
    console.log(data)
    return (
      <div className="search-form-scroll-container">
        <SearchForm search={data.search} location={location} />
      </div>
    )
  } else {
    return ''
  }
}